import Form from '../Form';
import Logo from '../Logo';
import Footer from '../Footer';

import './App.scss';

export default class App extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="Top-Part" key="Top-Part">
          <Logo />
          <Form />
        </div>
        <Footer key="footer" />
      </React.Fragment>
    );
  }
}
